import { connect } from 'react-redux'

import { PersonalizeIcon } from 'components/icons'
import { GOAL_STATES } from 'registry/constants'

import SetupGoal from './setup-goal'

function getText(ownProps) {
  if (ownProps.state != GOAL_STATES.COMPLETE)
    return 'Add a photo and a greeting.'
  return 'Your registry is looking good!'
}

function mapStateToProps(state, ownProps) {
  return {
    ...ownProps,
    icon: <PersonalizeIcon />,
    text: getText(ownProps),
  }
}

export default connect(mapStateToProps)(SetupGoal)
